import { IMemberServedTimespan } from './index.js'

export interface IMemberServed {
  Senate?: IMemberServedTimespan[]
  House?: IMemberServedTimespan[]
}
